export enum ELeasingRequestFileTypes {
  CLIENT_ID_CARD = 'CLIENT_ID_CARD',
  CLIENT_PHOTO = 'CLIENT_PHOTO',
  CLIENT_BANK_STATEMENT = 'CLIENT_BANK_STATEMENT',
  CLIENT_CONSENT = 'CLIENT_CONSENT',
  CLIENT_DOWN_PAYMENT = 'CLIENT_DOWN_PAYMENT',
  PAYMENT_ORDER = 'PAYMENT_ORDER',
  ACT_OF_ACCEPTANCE_UNSIGNED = 'ACT_OF_ACCEPTANCE_UNSIGNED',
  ACT_OF_ACCEPTANCE_SIGNED_FULLY = 'ACT_OF_ACCEPTANCE_SIGNED_FULLY',
  KAZAUTOZHOL_SPEC_UNSIGNED = 'KAZAUTOZHOL_SPEC_UNSIGNED',
  KAZAUTOZHOL_SPEC_SIGNED_FULLY = 'KAZAUTOZHOL_SPEC_SIGNED_FULLY'
}

export enum EFlashLogSource {
  REQUEST_CREATION = 'request_creation',
  DECISION_CREATION = 'decision_creation',
  CLIENT_DECISION = 'client_decision',
  REQUEST_FINANCED = 'request_financed',
  LEASE_HANDOVER = 'lease_handover',

  // Client Sales Contract
  DOCUMENTOLOG_SENT = 'documentolog_sent',
  DOCUMENTOLOG_CLIENT_SIGNED = 'documentolog_client_signed',
  DOCUMENTOLOG_ORG_SIGNED = 'documentolog_org_signed',
  DOCUMENTOLOG_COMPLETED = 'documentolog_completed',
  DOCUMENTOLOG_DECLINED = 'documentolog_declined',
  // -------------

  HANDOVER_DOCUMENTS_CLIENT_SIGNED = 'handover_documents_client_signed',
  HANDOVER_DOCUMENTS_ORG_SIGNED = 'handover_documents_org_signed',

  WAITING_FOR_DOWN_PAYMENT = 'waiting_for_down_payment',
  DOWN_PAYMENT_PAID = 'down_payment_paid',
  DOWN_PAYMENT_REFUND_REQUIRED = 'down_payment_refund_required'
}

export const LEASING_LOG_SOURCES = [
  EFlashLogSource.REQUEST_CREATION,
  EFlashLogSource.DECISION_CREATION,
  EFlashLogSource.CLIENT_DECISION,
  EFlashLogSource.REQUEST_FINANCED,
  EFlashLogSource.LEASE_HANDOVER,

  EFlashLogSource.DOCUMENTOLOG_SENT,
  EFlashLogSource.DOCUMENTOLOG_CLIENT_SIGNED,
  EFlashLogSource.DOCUMENTOLOG_ORG_SIGNED,
  EFlashLogSource.DOCUMENTOLOG_COMPLETED,
  EFlashLogSource.DOCUMENTOLOG_DECLINED,

  EFlashLogSource.HANDOVER_DOCUMENTS_CLIENT_SIGNED,
  EFlashLogSource.HANDOVER_DOCUMENTS_ORG_SIGNED,

  EFlashLogSource.WAITING_FOR_DOWN_PAYMENT,
  EFlashLogSource.DOWN_PAYMENT_PAID,
  EFlashLogSource.DOWN_PAYMENT_REFUND_REQUIRED
];

export enum EDownPaymentMethod {
  IOKA = 'IOKA',
  CASH = 'CASH'
}

export enum EDownPaymentStatus {
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  PENDING = 'PENDING',
  PENDING_CONFIRMATION = 'PENDING_CONFIRMATION',
  PAID = 'PAID'
}

export enum EScoringStatusCode {
  DRAFT = 'draft',
  VERIFICATION_PENDING = 'sms_verificating',
  WAITING_FOR_LEASING_RESPONSE = 'waiting_for_leasing_response',
  AWAITING_UNDERWRITER_DECISION = 'awaiting_underwriter_decision',
  APPROVED = 'approved',
  APPROVED_ALTERNATIVE = 'approved_alternative',
  APPROVED_BY_CLIENT = 'approved_by_client',
  WAITING_DOWN_PAYMENT = 'waiting_down_payment',
  WAITING_OF_FINANCING = 'waiting_of_financing',
  FINANCED = 'financed',
  COMPLETED = 'completed',
  DECLINED = 'declined',
  CANCELLED = 'cancelled',
  ERROR = 'error',
  AWAITING_KOMPRA_RESEND = 'awaiting_kompra_resend'
}

export const SCORING_STATUSES_CODES = new Set([
  EScoringStatusCode.DRAFT,
  EScoringStatusCode.VERIFICATION_PENDING,
  EScoringStatusCode.WAITING_FOR_LEASING_RESPONSE,
  EScoringStatusCode.AWAITING_UNDERWRITER_DECISION,
  EScoringStatusCode.APPROVED,
  EScoringStatusCode.APPROVED_BY_CLIENT,
  EScoringStatusCode.WAITING_DOWN_PAYMENT,
  EScoringStatusCode.WAITING_OF_FINANCING,
  EScoringStatusCode.FINANCED,
  EScoringStatusCode.COMPLETED,
  EScoringStatusCode.DECLINED,
  EScoringStatusCode.CANCELLED,
  EScoringStatusCode.ERROR,
  EScoringStatusCode.AWAITING_KOMPRA_RESEND
]);

export const SCORING_STATUSES_COLORS = {
  [EScoringStatusCode.DRAFT]: {
    bgColor: '#1E1E1E',
    textColor: 'white',
    colorWithoutBg: '#1E1E1E'
  },
  [EScoringStatusCode.VERIFICATION_PENDING]: {
    bgColor: '#023D3D',
    textColor: 'white',
    colorWithoutBg: '#023D3D'
  },
  [EScoringStatusCode.WAITING_FOR_LEASING_RESPONSE]: {
    bgColor: '#1E1E1E',
    textColor: 'white',
    colorWithoutBg: '#1E1E1E'
  },
  [EScoringStatusCode.AWAITING_UNDERWRITER_DECISION]: {
    bgColor: '#FFD023',
    textColor: '#111827',
    colorWithoutBg: '#FFD023'
  },
  [EScoringStatusCode.APPROVED]: {
    bgColor: '#EAFFF1',
    textColor: '#0CAF60',
    colorWithoutBg: '#0CAF60'
  },
  [EScoringStatusCode.APPROVED_ALTERNATIVE]: {
    bgColor: '#EAFFF1',
    textColor: '#0CAF60',
    colorWithoutBg: '#0CAF60'
  },
  [EScoringStatusCode.APPROVED_BY_CLIENT]: {
    bgColor: '#1F9AFF',
    textColor: 'white',
    colorWithoutBg: '#1F9AFF'
  },
  [EScoringStatusCode.WAITING_DOWN_PAYMENT]: {
    bgColor: '#FFD023',
    textColor: '#111827',
    colorWithoutBg: '#FFD023'
  },
  [EScoringStatusCode.WAITING_OF_FINANCING]: {
    bgColor: '#1F9AFF',
    textColor: 'white',
    colorWithoutBg: '#1F9AFF'
  },
  [EScoringStatusCode.FINANCED]: {
    bgColor: '#059365',
    textColor: 'white',
    colorWithoutBg: '#059365'
  },
  [EScoringStatusCode.COMPLETED]: {
    bgColor: '#0CAF60',
    textColor: 'white',
    colorWithoutBg: '#0CAF60'
  },
  [EScoringStatusCode.DECLINED]: {
    bgColor: '#E03137',
    textColor: 'white',
    colorWithoutBg: '#E03137'
  },
  [EScoringStatusCode.CANCELLED]: {
    bgColor: '#E03137',
    textColor: 'white',
    colorWithoutBg: '#E03137'
  },
  [EScoringStatusCode.ERROR]: {
    bgColor: '#E03137',
    textColor: 'white',
    colorWithoutBg: '#E03137'
  },
  [EScoringStatusCode.AWAITING_KOMPRA_RESEND]: {
    bgColor: '#FFD023',
    textColor: '#111827',
    colorWithoutBg: '#FFD023'
  }
};
